<template>
  <div class="main">
    <my_menu active_name="1-0" :open_active="['1']"></my_menu>

    <div class="content">
      <div class="button_div">
        <Button type="primary" size="small" style="font-size: 12px" @click="click_add">
          <Icon type="md-add" />新增版本
        </Button>
      </div>

      <div class="table_box">
        <Spin fix size="large" v-if="table_loading"></Spin>
        <Table
          size="small"
          :height="windowHeight - 75"
          border
          :columns="columns"
          :data="table_data"
        >
          <template #apk_download_url="{ row }">
            <a :href="row.apk_download_url" style="color: #0466dd">
              <Icon type="ios-cloud-download-outline" />下载
            </a>
          </template>

          <template #update_status="{ row }">
            <Tag color="info" size="small" v-if="row.update_status == 0">不更新</Tag>
            <Tag color="error" size="small" v-if="row.update_status == 1">强制更新</Tag>
            <Tag color="primary" size="small" v-if="row.update_status == 2"
              >不强制更新</Tag
            >
          </template>
        </Table>
      </div>
    </div>

    <Modal width="420" v-model="add_show" title="新增版本" :footer-hide="true">
      <div class="add_ip_div">
        <div class="add_ip_field">MD5：</div>
        <Input
          v-model="add_data.apk_md5"
          placeholder="请输入apk md5"
          style="width: 250px"
        />
      </div>
      <div class="add_ip_div">
        <div class="add_ip_field">版本号：</div>
        <Input
          v-model="add_data.version"
          placeholder="请输入版本号"
          style="width: 250px"
        />
      </div>
      <div class="add_ip_div">
        <div class="add_ip_field">版本类型：</div>
        <Input
          v-model="add_data.version_status"
          placeholder="0线上1测试"
          style="width: 250px"
        />
      </div>
      <div class="add_ip_div">
        <div class="add_ip_field">APK：</div>
        <Upload
          type="drag"
          :action="upload_url + add_data.version"
          :on-success="upload_success"
          :before-upload="upload_before"
          :format="['apk']"
          :on-format-error="upload_file_error"
        >
          <Button icon="ios-cloud-upload-outline" type="primary">上传apk</Button>
          大小：{{ add_data.file_size }} B
        </Upload>
      </div>
      <div class="add_ip_div">
        <div class="add_ip_field">更新说明：</div>
        <Input
          v-model="add_data.version_content"
          placeholder="请输入更新说明"
          style="width: 380px"
        />
      </div>
      <div class="add_ip_div">
        <div class="add_ip_field">更新类型：</div>
        <Select v-model="add_data.update_status" style="width: 200px">
          <Option value="0">不更新</Option>
          <Option value="1">强制更新</Option>
          <Option value="2">不强制更新</Option>
        </Select>
      </div>

      <div class="add_button_confirm">
        <Button type="primary" style="font-size: 10px" @click="add_confirm">
          <Icon type="md-add" /> 确认添加
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import my_menu from "@/component/admin/menu/menu.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      //系统列表
      table_data: [],
      columns: [],
      table_loading: false,
      page: 1,

      add_show: false,
      add_data: {
        apk_md5: "",
        version: "",
        version_status: 0,
        version_content: "",
        update_status: "0",
        apk_url: "",
        file_size: "0",
        file_object: "",
      },
      upload_url:
        process.env.VUE_APP_HOST +
        "/app/version/upload_apk?token=" +
        this.$cookies.get("admin_token") +
        "&version=",
    };
  },

  mounted() {
    this.window_change();
    this.get_version_list();
  },

  methods: {
    add_confirm() {
      if (this.add_data.version_content == "") {
        this.$Message.error("请输入更新说明");
        return false;
      }
      if (this.add_data.file_object == "") {
        this.$Message.error("请先上传apk或等待上传完成");
        return false;
      }

      var that = this;
      var obj = {
        update_status: this.add_data.update_status,
        version: this.add_data.version,
        version_status: this.add_data.version_status,
        version_content: this.add_data.version_content,
        file_object: this.add_data.file_object,
        file_size: this.add_data.file_size,
        apk_md5: this.add_data.apk_md5,
      };
      http("post", process.env.VUE_APP_HOST + "/app/version/version_update", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_version_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    upload_file_error() {
      this.$Message.error("只可以上传apk");
      return false;
    },

    upload_before() {
      console.log(123);
      if (this.add_data.version == "") {
        this.$Message.error("请先输入版本号");
        return false;
      }
    },

    upload_success(e) {
      console.log(e);
      this.add_data.file_object = e.data.img_object_name;
      this.add_data.file_size = e.data.file_size;
    },

    click_add() {
      this.add_show = true;
    },

    //获取版本列表
    get_version_list() {
      var that = this;
      var obj = {
        page: this.page,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/app/version/version_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.table_data = res.data.table_data;
            that.columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.add_button_confirm {
  display: flex;
  justify-content: flex-end;
}

.add_ip_div {
  margin-bottom: 10px;
}

.button_div {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  padding: 10px;
  width: calc(100% - 220px);
  background-color: #fff;
  position: absolute;
  right: 10px;
  top: 10px;
  height: calc(100vh - 20px);
  border-radius: 5px;
}

.main {
  background: #ececec;
  min-height: 100vh;
}
</style>
